import {
  cloudChiprApi,
  CommitmentType,
} from "../../../../services/cloudchipr.api";
import { RootState } from "@/store/store";
import { getRecommendationFiltersPreferenceKey } from "@/store/commitments/thunks/recommendations/user-preference/getRecommendationFiltersUserPreferenceByKeyThunk";

const selector =
  cloudChiprApi.endpoints.getUsersMeCurrentPreferenceByKey.select;

export const initialRecommendationFiltersPreferenceSelector = (
  state: RootState,
  key: CommitmentType,
) => {
  const preferenceKey = getRecommendationFiltersPreferenceKey(key);

  const response = selector({ key: preferenceKey })(state);

  if (!response?.data) {
    return "";
  }
  return JSON.parse(response?.data?.value ?? "");
};
